import { FunctionComponent } from 'react';
import { ChipStack, useGameStateSlice, useModifiers, useIsLargerThanWide, useIsPortrait } from '@pp/core';

import { WideChipStackControlsConnected } from '../../wideChipStackControls';
import styles from './chipStackCell.module.css';

export const ChipStackCellConnected: FunctionComponent = () => {
  const isWide = useIsLargerThanWide();
  const isPortrait = useIsPortrait();
  const isBetsOpen = useGameStateSlice.isBetsOpenStatus();
  const mods = useModifiers(styles, 'chipStackCell', { close: !isBetsOpen });
  if (!isWide && !isPortrait) return null;
  return (
    <div className={`${styles.chipStackCell} ${mods}`}>
      {!isWide && isPortrait ? (
        <div className={`${styles.chipStackCell__revolver}`}>
          <ChipStack.Revolver />
        </div>
      ) : null}
      {isWide ? <WideChipStackControlsConnected /> : null}
    </div>
  );
};
